import { render, staticRenderFns } from "./devicetatistics.vue?vue&type=template&id=4714acda&scoped=true"
import script from "./devicetatistics.vue?vue&type=script&lang=js"
export * from "./devicetatistics.vue?vue&type=script&lang=js"
import style0 from "./devicetatistics.vue?vue&type=style&index=0&id=4714acda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4714acda",
  null
  
)

export default component.exports